import script from "./FormSteps.vue?vue&type=script&lang=js"
export * from "./FormSteps.vue?vue&type=script&lang=js"

import "./FormSteps.vue?vue&type=style&index=0&id=604567c0&lang=scss"

const __exports__ = script;

export default __exports__